import { useCallback } from "react";
import axiosConfig from "../../axiosConfig";

const useBillingApi = () => {
  const fetchInvoices = useCallback(async () => {
    return axiosConfig.get("/billing/get-invoices");
  }, []);

  const subscriptionAction = useCallback(async (payload = {}) => {
    return axiosConfig.post("/billing/subscription-action", payload);
  }, []);

  const fetchPlans = useCallback(async () => {
    return axiosConfig.get("/get-plans");
  }, []);

  const fetchCards = useCallback(async () => {
    return axiosConfig.get("/billing/cards");
  }, []);

  const addCard = useCallback(async (payload = {}) => {
    return axiosConfig.post("/billing/cards", payload);
  }, []);

  const setDefaultCard = useCallback(async (paymentMethodId) => {
    return axiosConfig.put(`/billing/cards/${paymentMethodId}/default`);
  }, []);

  const deleteCard = useCallback(async (paymentMethodId) => {
    return axiosConfig.delete(`/billing/cards/${paymentMethodId}`);
  }, []);

  return {
    fetchInvoices,
    subscriptionAction,
    fetchPlans,
    fetchCards,
    addCard,
    setDefaultCard,
    deleteCard,
  };
};

export default useBillingApi;

